import { render, staticRenderFns } from "./preAssessment.vue?vue&type=template&id=5228eea4&"
import script from "./preAssessment.vue?vue&type=script&lang=js&"
export * from "./preAssessment.vue?vue&type=script&lang=js&"
import style0 from "./preAssessment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports